import React from 'react';
import './AdvancedBox.scss';
import { connect } from 'react-redux';
import * as actions from "store/actions/index";
import AdvancedSearch from 'Flow2/components/AdvancedBox/AdvancedSearch/AdvancedSearch';
import { isPorscheArchiv } from "Flow2/components/CustomCollections/CustomDataUtil/CustomDataUtil";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { injectIntl } from 'react-intl';
import { faEllipsisV } from '@fortawesome/free-solid-svg-icons';

class AdvancedBox extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showAdvanced: false
        };
    }

    onAdvancedBtn = () => {
        this.setState({ showAdvanced: true });
    }

    componentDidMount() { }

    showAdvancedBtn = () => {
        return (
            <div className="AdvancedBtnTop" onClick={this.onAdvancedBtn}>
                <span className="">
                    <FontAwesomeIcon icon={faEllipsisV} />
                </span>
            </div>)
    }

    render() {
        if (isPorscheArchiv()) {
            return (
                <div className="AdvancedBox">
                    {this.showAdvancedBtn()}
                    {this.state.showAdvanced && (
                        <AdvancedSearch isOpened={this.state.showAdvanced} onClose={() => this.setState({ showAdvanced: false })} />)}
                </div>)
        }
        return null;
    }
}

const mapStateToprops = (state) => ({
    flexObjects: state.share.flexObjects,
})

const mapDispatchToProps = (dispatch) => ({
    updateflexObjects: (obj) => dispatch(actions.updateFlexObjects(obj)),
})

export default connect(mapStateToprops, mapDispatchToProps)(injectIntl(AdvancedBox));